<!--支持showDrawer-->
<template>
  <el-drawer
    ref="drawerRef"
    :title="title"
    :direction="direction"
    :modal="modal"
    :close-on-click-modal="closeOnClickModal"
    :size="size"
    :show-close="showClose"
    :model-value="true"
    :teleported="false"
    :append-to-body="false"
    :before-close="beforeClose"
    modal-class="easy-drawer easy-popup"
    @closed="destory"
  >
    <component :is="defaultSlot" />

    <!--header slot-->
    <template v-if="headerSlot" #header>
      <component :is="headerSlot" />
    </template>

    <!--footer slot-->
    <template v-if="footerSlot" #footer>
      <component :is="footerSlot" />
    </template>
  </el-drawer>
</template>
<script lang="ts" setup>
import { ref, Slot, Ref, provide } from 'vue';
/**
 * ### drawer容器组件
 * 包含 header/footer 插槽
 * 当drawer包含的组件存在动态修改的header/footer内容时可通过改组件实现
 */

type DoneFn = (cancel?: boolean) => void;

const props = defineProps<{
  /**
   * ### drawer标题
   */
  title: string;
  /**
   * ### drawer 弹出方向
   */
  direction: 'ltr' | 'rtl' | 'ttb' | 'btt';
  /**
   * ### 是否显示蒙层
   */
  modal: boolean;
  /**
   * ### 点击蒙层时是否关闭该drawer
   */
  closeOnClickModal: boolean;
  /**
   * ### drawer尺寸
   */
  size: string;
  /**
   * ### 是否显示关闭按钮
   */
  showClose: boolean;
  /**
   * ### 关闭前回调
   */
  beforeClose?: (done: DoneFn) => void;

  defaultSlot: Slot;
  headerSlot: () => Ref<Slot | undefined>;
  footerSlot: () => Ref<Slot | undefined>;

  destory: () => void; // 关闭后, 销毁dom

  popupCtx: {
    done: (r?: any) => void;
  };
}>();

defineExpose({
  handleClose
});

const headerSlot = props.headerSlot();
const footerSlot = props.footerSlot();

const drawerRef = ref();
function handleClose() {
  drawerRef.value?.handleClose();
}

// 提供给PopupCloseButton
provide('PopupContainer', handleClose);
</script>
